const actions: Record<string, string> = {
  "dataset.created": "Datasættet blev oprettet",
  "dataset.updated": "Datasættets oplysninger blev ændret",
  "dataset.archived": "Datasættet blev arkiveret",
  "dataset.reopened": "Datasættet blev genåbnet",
  "dataset.unarchived": "Datasættet blev genåbnet",
  "record.created": "Række tilføjet",
  "record.updated": "Række ændret",
  "record.deleted": "Række slettet",
  "record.restored": "Række gendannet",
  "schema.activated": "Felter opdateret",
  "schema.drift_proposed": "Forslag til nye felter",
  "source.created": "Datakilde tilføjet",
  "source.updated": "Datakilde ændret",
  "mapping.activated": "Importprofil aktiveret",
  "import.requested": "Import sat i kø",
  "job.cancelled": "Kørsel annulleret",
  "view.created": "Kort oprettet",
  "view.updated": "Kort ændret",
  "automation.activated": "Regel aktiveret",
  "automation.updated": "Regel ændret",
  "schedule.saved": "Tidsplan gemt",
  "schedule.disabled": "Tidsplan stoppet",
  "report.created": "Rapport oprettet",
  "grant.updated": "Adgang ændret",
  "ai.draft_created": "AI-forslag oprettet",
};
export const activityTitle = (action: string) =>
  actions[action] ?? "Ændring registreret";
export function activityDetail(event: {
  action: string;
  metadata?: Record<string, unknown>;
}) {
  const m = event.metadata ?? {};
  if (event.action.startsWith("record."))
    return m.runId ? "Via import" : "Direkte registrering";
  if (event.action === "schema.activated" && m.version)
    return `Schema version ${m.version}`;
  if (event.action === "mapping.activated" && m.version)
    return `Importprofil version ${m.version}`;
  return "";
}
